module.exports = __webpack_public_path__ + "static/neon-48af9c10aefe23a236ea4d01d443dd90.png";